<div class="d-flex justify-content-center h-100 align-items-center">
	<div class="spinner-border" [ngClass]="colorClass" [style.height.rem]="size" [style.width.rem]="size" role="status">
		<span class="sr-only"> </span>
	</div>
</div>
